
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/sales?${queryString}`);
    return response.data;
  },

  async getById(id) {
    const response = await https.get(`/sales/${id}`);
    return response.data.data;
  },

  async import(file, updateExisting = false) {
    const formData = new FormData();
    formData.append('excel_file', file);
    if (updateExisting) formData.append('update_existing', '1');
    const response = await https.post(`/sale-import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Download all orders as an import-compatible .xlsx (respects current filters).
  // Returns a Blob; caller triggers the browser download.
  async export(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/sale-export${queryString ? `?${queryString}` : ''}`, {
      responseType: 'blob',
    });
    return response.data;
  },

  async add(payload) {
    const response = await https.post(`/sales`, payload);
    return response.data;
  },
  async update(id, payload) {
    const response = await https.put(`/sales/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/sales/${id}`);
    return response.data;
  },

  // Orders Review #29: order activity trail.
  async getActivity(id) {
    const response = await https.get(`/sales/${id}/activity`);
    return response.data?.data || [];
  },

  // Orders Review #27: status-only write, never touches any other field.
  async updateStatus(id, status) {
    const response = await https.patch(`/sales/${id}/status`, { status });
    return response.data;
  },

  // Orders Review #32: same status-only write, across many orders at once.
  async bulkUpdateStatus(ids, status) {
    const response = await https.post(`/sales/bulk-status`, { ids, status });
    return response.data;
  },

  // Orders Review #33: trash/restore.
  async getTrashed(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/sales-trash?${queryString}`);
    return response.data;
  },
  async restore(id) {
    const response = await https.post(`/sales/${id}/restore`);
    return response.data;
  },

  // Quality Down & Fibers wholesale orders: manual order -> production link.
  async sendToProduction(id) {
    const response = await https.post(`/sales/${id}/send-to-production`);
    return response.data;
  },

  // Parses a QuickBooks invoice PDF into a draft — never persisted server-side,
  // the caller pre-fills the add-sale form with the result for review.
  async parseInvoicePdf(file) {
    const formData = new FormData();
    formData.append('pdf', file);
    const response = await https.post(`/sales/parse-invoice-pdf`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
});
